import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function StrategyLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer mb-4" role="menu">
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/categories/strategy" id="categories-strategy" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.strategy" defaultMessage="Strategy" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/board-and-card" id="categories-boardandcard" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.board-and-card" defaultMessage="Board and Card" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/city-builder" id="categories-citybuilder" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.city-builder" defaultMessage="City Builder" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/grand-strategy" id="categories-grandstrategy" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.grand-strategy" defaultMessage="Grand Strategy" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/rts" id="categories-realtimestrategy" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.rts" defaultMessage="Real-Time Strategy" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/tower-defense" id="categories-towerdefence" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.tower-defense" defaultMessage="Tower Defence" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/turn-based-strategy" id="categories-turnbasedstrategy" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="strategy-links.link.turn-based-strategy" defaultMessage="Turn-Based Strategy" />
        </TrackingLink>
      </li>
    </ul>
  );
}

StrategyLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

StrategyLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
